import type { WabunkaReservationFormStep2 } from '@/wabunka-src/features/Experience/subFeatures/Reservation/models/wabunkaReservations';

const hasParticipantInput = (step2: WabunkaReservationFormStep2): boolean =>
  [step2.participantFirstName, step2.participantLastName, step2.forSomeoneElseEmail, step2.forSomeoneElsePhoneNumber, step2.forSomeoneElseNationality].some((value) => value !== '');

/** 会社名を変えたときの、参加代表者の入力（代理予約）のチェック。会社の予約は参加者が予約者と別のことが多いので、会社名を入れたら入れ、消したら外す。入れかけの参加者は隠さない（D-042） */
export const resolveSomeoneElseFormOnCompanyNameChange = (step2: WabunkaReservationFormStep2, nextCompanyName: string): boolean => {
  const hadCompanyName = step2.companyName !== '';
  const hasCompanyName = nextCompanyName !== '';
  if (!hadCompanyName && hasCompanyName) return true;
  if (hadCompanyName && !hasCompanyName && !hasParticipantInput(step2)) return false;
  return step2.shouldShowSomeoneElseForm;
};
